/* eslint-disable max-len */
import Dispatchers from '@/mixins/dispatchers';
const BastanteoItem = () => import(/* webpackChunkName: "BastanteoItem" */ '@/views/shared/bastanteo/bastanteo-item');

export default {
    name: 'BastanteoBankAccounts',

    mixins: [Dispatchers],

    components: {
        BastanteoItem
    },

    /**
     * @override
     */
    data() {
        return {
            opened: false,
            docsPending: 0
        };
    },
    props: {
        itemActive: {
            type: Object,
            required: false
        },
        items: {
            items: Array,
            required: true
        }
    },

    methods: {
        /**
         * Muestra documento en ventana flotante
         * @param {Object} item documento a mostrar
         */
        showDocumentInWindow(item) {
            item.type = {
                type: 'account',
                uuid: item.uuid_account,
                is_validated: item.is_validated
            };
            this.$store.dispatch('bastanteoStore/setNewFloatWindow', item);
        }
    },
    /**
     * @override
     */
    mounted() {
        const docsPendingRequired = this.items.filter(
            x => x.data.is_required === true && (!x.data.is_validated || x.data.is_validated === null)
        );
        this.docsPending = docsPendingRequired.length;
        this.$root.$emit('emit_items_not_validated', docsPendingRequired);
    }
};
